export default "__VITE_IMAGE_ASSET__b1edb006__";